var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "location_1_",
    "data-name": "location (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.142,
    height: 19.504,
    viewBox: "0 0 17.142 19.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1249",
    "data-name": "Group 1249",
    transform: "translate(2.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1248",
    "data-name": "Group 1248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4687",
    "data-name": "Path 4687",
    d: "M97.285,0a6.283,6.283,0,0,0-5.109,9.943L96.8,17.164a.571.571,0,0,0,.962,0l4.648-7.246A6.285,6.285,0,0,0,97.285,0Zm0,9.142a2.857,2.857,0,1,1,2.857-2.857A2.86,2.86,0,0,1,97.285,9.142Z",
    transform: "translate(-91)",
    fill: "#dadde5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1251",
    "data-name": "Group 1251",
    transform: "translate(0 13.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1250",
    "data-name": "Group 1250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4688",
    "data-name": "Path 4688",
    d: "M44.038,344.7l-2.877,4.5a1.889,1.889,0,0,1-3.18,0L35.1,344.7c-2.536.586-4.1,1.66-4.1,2.944,0,2.227,4.416,3.428,8.571,3.428s8.571-1.2,8.571-3.428C48.142,346.355,46.577,345.281,44.038,344.7Z",
    transform: "translate(-31 -344.695)",
    fill: "#dadde5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation1);
export default __webpack_public_path__ + "static/media/location (1).dda739ad253c2a16c007d050a4a54c5d.svg";
export { ForwardRef as ReactComponent };